import React, { Component } from 'react';
import { array, bool, func, number, string } from 'prop-types';

import ViewSwitcher from 'ps-components/ViewSwitcher/ViewSwitcher';
import { shortDateString } from 'ps-components/lib/formatters';
import LoadingList from '../LoadingStates/LoadingList';
import ReloadableSection from '../ErrorStates/ReloadableSection';
import Report from './Report/Report';
import { FAVORITE_REPORTS, RECENT_REPORTS } from '../../../reducers/modules/recentReports/recentReports';

import './RecentReports.scss';

const MAX_MESSAGE = 'You have reached the max retries, please refresh the whole page.';
const DEFAULT_MESSAGE = 'An error occured loading the Recent Reports';
const MAX_RETRIES = 3;
const tabList = ['My Favorites', 'Recent'];

class RecentReports extends Component {
  static propTypes = {
    browseReportsClick: func,
    error: string,
    loading: bool,
    reFetchReports: func,
    recentReports: array,
    reportLinkClick: func,
    retries: number,
    refetchFavorites: func,
    favoriteReports: array,
    favoritesLoading: bool,
    favoritesError: string,
    favoritesRetries: number,
    reportTypeTabClick: func,
    selectedTabIndex: number
  };

  constructor(props) {
    super(props);

    this.handleTabSwitch = this.handleTabSwitch.bind(this);
    this.handleReportClick = this.handleReportClick.bind(this);
  }

  handleTabSwitch(index) {
    this.props.reportTypeTabClick(index);
  }

  handleReportClick(reportId) {
    const { reportLinkClick } = this.props;

    reportLinkClick(reportId);
  }

  renderHeader() {
    const { browseReportsClick } = this.props;

    return (
      <div className="recent__reports--header">
        <div className="recent__reports--title">Reports</div>
        <div className="recent__reports--link" onClick={browseReportsClick}>
          Browse Reports
        </div>
      </div>
    );
  }

  renderReports() {
    const {
      recentReports,
      favoriteReports,
      favoritesLoading,
      loading,
      error,
      favoritesError,
      retries,
      favoritesRetries,
      reFetchReports,
      refetchFavorites,
      selectedTabIndex
    } = this.props;

    // Default to Favorite Reports
    let reports = favoriteReports;
    let isLoading = favoritesLoading;
    let hasError = favoritesError && favoritesError.length > 0;
    let numRetries = favoritesRetries;
    let reloadAction = refetchFavorites;

    if (selectedTabIndex === RECENT_REPORTS) {
      reports = recentReports;
      isLoading = loading;
      hasError = error && error.length > 0;
      numRetries = retries;
      reloadAction = reFetchReports;
    }

    const errorMessage = numRetries <= MAX_RETRIES ? DEFAULT_MESSAGE : MAX_MESSAGE;
    const showReload = numRetries <= MAX_RETRIES;

    if (isLoading || favoritesLoading) {
      return <LoadingList />;
    }

    if (hasError) {
      return <ReloadableSection errorMessage={errorMessage} reloadAction={reloadAction} showReload={showReload} />;
    }

    if (selectedTabIndex === FAVORITE_REPORTS && reports.length === 0) {
      return <p className="no-favorites">You don&apos;t have any favorite reports.</p>;
    }

    return reports.map(report => {
      const lastModified = new Date(report.lastModified);
      const lastModifiedDateString = shortDateString(lastModified);

      return (
        <Report
          id={report.id}
          key={report.id}
          lastModified={lastModifiedDateString}
          lastModifiedBy={`${report?.lastModifiedBy?.firstName || ''} ${report?.lastModifiedBy?.lastName || ''}`}
          name={report.name}
          reportLinkClick={this.handleReportClick.bind(this, report.id)}
          scope={report?.scope?.code || ''}
        />
      );
    });
  }

  render() {
    const { selectedTabIndex } = this.props;

    return (
      <div className="recent__reports">
        {this.renderHeader()}
        <ViewSwitcher
          className="reports__switcher"
          isSticky={true}
          tabList={tabList}
          activeTab={selectedTabIndex}
          tabSwitch={this.handleTabSwitch}
        />
        <div className="reports">{this.renderReports()}</div>
      </div>
    );
  }
}

export default RecentReports;
